import React from 'react';
import ChirpPropShapes from 'javascripts/shared/chirp_prop_shapes';
import { useMediaQuery } from 'react-responsive';
import { breakpoints } from 'javascripts/shared/utils/breakpoint_utils';
import { AuthorByline } from 'javascripts/components/book_card/author_byline';
import { CoverImage } from 'javascripts/components/cover_image';

import styles from 'stylesheets/components/book_card_horizontal_condensed';

export function BookCardHorizontalCondensed({
  audiobook,
}) {
  const isMobile = useMediaQuery({ maxWidth: breakpoints.xs });

  function renderListPrice() {
    if (audiobook.currentProduct.isFreeListing) {
      return null;
    }
    if (!audiobook.currentProduct.showListingPrice) {
      return null;
    }
    return (
      <div className={styles.listPrice} aria-hidden='true'>
        {audiobook.currentProduct.listingPrice}
      </div>
    );
  }

  function renderPrices() {
    if (audiobook.futureSaleDate) {
      return (
        <div className={styles.pricing}>
          <div className={styles.futureSaleDate}>
            <span className={styles.releaseDateLabel}>Release:</span>
            <span>{audiobook.futureSaleDate}</span>
          </div>
        </div>
      );
    }

    if (!audiobook.currentProduct) {
      return null;
    }

    return (
      <div className={styles.pricing}>
        {renderListPrice()}
        <div className={styles.discountPrice} aria-label={`Discount price ${audiobook.currentProduct.discountPrice}`}>
          {audiobook.currentProduct.discountPrice}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.audiobook} key={audiobook.id} data-testid='book-card-horizontal-condensed'>
      <div className={styles.cover}>
        <CoverImage
          coverUrl={audiobook.coverUrl}
          bookTitle={audiobook.displayTitle}
          bookAuthor={audiobook.displayAuthors}
          currentProduct={audiobook.currentProduct}
          bookId={audiobook.id}
        />
      </div>
      <div className={styles.audiobookDetails}>
        <h3 className={styles.title}>
          <span>{audiobook.displayTitle}</span>
        </h3>
        <AuthorByline audiobook={audiobook} disableLinks />
        {isMobile ? renderPrices() : null}
      </div>
      <div className={styles.priceDetails}>
        {isMobile ? null : renderPrices()}
      </div>
    </div>
  );
}

BookCardHorizontalCondensed.propTypes = {
  audiobook: ChirpPropShapes.audiobook.isRequired,
};
